import { OpaccVerification } from './classes/opacc.class.verification.js';

export const opaccVerificationPlugin = new OpaccVerification();